import React, { Fragment } from "react";
import moment from "moment";

import MenuModal from "./MenuModal";
import AddModal from "./AddModal";
import EditModal from "./EditModal";
import UndoModal from "./UndoModal";
import DeleteModal from "./DeleteModal";
import PostingModal from "./PostingModal";
import RefundModal from "./RefundModal";

const SalaryCalculationModals = ({
  modalState,
  openModal,
  closeModal,
  closePostingRefundModal,
  fetchSalaryCalculation,
  pageNumber,
  workers,
  skills,
  rangeDate,
  setLoadingPosting,
  setLoadingRefund,
}) => {
  if (!modalState.open) return null;

  const modalProps = {
    dataModal: modalState.data,
    activeModal: true,
    closeModal,
  };

  const commonUpdate = () => fetchSalaryCalculation({ page: pageNumber });

  return (
    <Fragment>
      {modalState.type === "menu" && (
        <MenuModal
          {...modalProps}
          setModalAdd={(data) => openModal("add", data)}
          setModalEdit={(data) => openModal("edit", data)}
          setModalUndo={(data) => openModal("undo", data)}
          setModalDelete={(data) => openModal("delete", data)}
          setModalType={(t) => openModal(t, modalState.data)}
        />
      )}

      {modalState.type === "add" && (
        <AddModal {...modalProps} setUpdate={commonUpdate} workers={workers} skills={skills} modalType="add" />
      )}

      {modalState.type === "edit" && <EditModal {...modalProps} setUpdate={commonUpdate} modalType="edit" />}

      {modalState.type === "undo" && <UndoModal {...modalProps} setUpdate={commonUpdate} modalType="undo" />}

      {modalState.type === "delete" && <DeleteModal {...modalProps} setUpdate={commonUpdate} modalType="delete" />}

      {modalState.type === "posting" && (
        <PostingModal
          {...modalProps}
          setUpdate={commonUpdate}
          setLoadingPosting={setLoadingPosting}
          startDate={rangeDate[0] ? moment(rangeDate[0]).format("YYYY-MM-DD") : undefined}
          endDate={rangeDate[1] ? moment(rangeDate[1]).format("YYYY-MM-DD") : undefined}
          closeModal={closePostingRefundModal}
        />
      )}

      {modalState.type === "refund" && (
        <RefundModal
          {...modalProps}
          setUpdate={commonUpdate}
          setLoadingRefund={setLoadingRefund}
          startDate={rangeDate[0] ? moment(rangeDate[0]).format("YYYY-MM-DD") : undefined}
          endDate={rangeDate[1] ? moment(rangeDate[1]).format("YYYY-MM-DD") : undefined}
          closeModal={closePostingRefundModal}
        />
      )}
    </Fragment>
  );
};

export default SalaryCalculationModals;
